import React, { useContext } from 'react'
import { DataContext } from '../../Context/Context'

import "./StoreSortOption.css"
function StoreSortOption() {
    const value = useContext(DataContext);
    const [products, setProducts] = value.products;
    const numberOfProducts = products.length;
    return (
        
        <>
            <div className="filter-sort-grid mb-0 d-none d-md-block ">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-10">
                        <p className='mb-0 d-block ' style={{ width: '100px' }}> بر اساس :</p>
                        <select className='form-control form-select fs13' name="" id="">
                            <option className='fs13' value="manual">جدیدترین</option>
                            <option className='fs13' value="best-selling">پرفروش ترین </option>
                            <option className='fs13' value="price-ascending">بالاترین قیمت</option>
                            <option className='fs13' value="price-descending">پایین ترین قیمت</option>
                        </select>
                    </div>
                    <div className='d-flex align-items-center gap-10'>
                        <p className="mb-0"> {numberOfProducts} محصول </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StoreSortOption 